import { FunctionComponent } from "react";
import AdminDashboard from "./pages/Admin/Dashboard";
import AdminProfile from "./pages/Admin/Profile";
import AdminEditProfile from "./pages/Admin/Profile/Edit";
import Authorizers from "./pages/Admin/Dashboard/Authorizers";
import MotionReps from "./pages/Admin/Dashboard/MotionReps";
import User from "./pages/Admin/User";
import ClientPage from "./pages/Client/";
import AdminUserEditProfile from "./pages/Admin/User/Edit";
import ClientNew from "./pages/Admin/Client/New";
import ClientEdit from "./pages/Admin/Client/Edit";
import NoMatch from "./pages/NoMatch";
import FormPage from "./pages/Client/Form";
import StatusReport from "./pages/Admin/StatusReport";
import ChangePassword from "./pages/ChangePassword";

type RouteType = {
  path: string;
  name: string;
  Component: FunctionComponent<unknown>;
};

type RoutesType = RouteType[];

export const adminRoutes: RoutesType = [
  { path: "/admin", name: "Main Dashboard", Component: AdminDashboard },
  { path: "/admin/clients", name: "Clients", Component: AdminDashboard },
  { path: "/admin/dashboard", name: "Clients", Component: AdminDashboard },
  { path: "/admin/profile", name: "Profile", Component: AdminProfile },
  {
    path: "/admin/profile/edit",
    name: "Edit Profile",
    Component: AdminEditProfile,
  },
  {
    path: "/admin/authorizers",
    name: "Authorizers",
    Component: Authorizers,
  },
  { path: "/admin/motion", name: "Motion", Component: MotionReps },
  {
    path: "/admin/user/:user_id",
    name: "Admin User",
    Component: User,
  },
  {
    path: "/admin/user/:id/edit",
    name: "Admin User Edit",
    Component: AdminUserEditProfile,
  },
  {
    path: "/admin/client/new",
    name: "Admin New Client",
    Component: ClientNew,
  },
  {
    path: "/admin/client/:client_id(\\d+)",
    name: "Admin Client Profile",
    Component: ClientPage,
  },
  {
    path: "/admin/client/:client_id/edit",
    name: "Admin Client Edit",
    Component: ClientEdit,
  },
  {
    path: "/admin/client/:client_id/form/new",
    name: "Admin New Client Form",
    Component: NoMatch,
  },
  {
    path: "/admin/client/:client_id(\\d+)/form/:file_id(\\d+)",
    name: "Client Form",
    Component: FormPage,
  },
  {
    path: "/admin/client/:client_id/form/:fid/edit",
    name: "Admin Edit Client Form",
    Component: NoMatch,
  },
  {
    path: "/admin/users/authorizers",
    name: "Admin Authorizers",
    Component: NoMatch,
  },
  {
    path: "/admin/users/reps",
    name: "Admin reps",
    Component: NoMatch,
  },
  {
    path: "/admin/users/new",
    name: "Admin New User",
    Component: NoMatch,
  },
  {
    path: "/admin/users/:user_id",
    name: "Admin User Details",
    Component: NoMatch,
  },
  {
    path: "/admin/users/:user_id/edit",
    name: "Admin Edit User",
    Component: NoMatch,
  },
  {
    path: "/admin/profile",
    name: "Admin Profile",
    Component: NoMatch,
  },
  {
    path: "/admin/profile/edit",
    name: "Admin Edit Profile",
    Component: NoMatch,
  },
  {
    path: "/admin/change-password",
    name: "Change Password",
    Component: ChangePassword,
  },
  {
    path: "/admin/status-report",
    name: "Admin Status Report",
    Component: StatusReport,
  }
];
